module.exports = __webpack_public_path__ + "static/media/goldStar.ae30e4c0.svg";